export default "__VITE_ASSET__7lmonB9H__"